// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__2P5Vq","counter--error":"counter_counter--error___hStk"};